import React from 'react';
import { Camera } from 'lucide-react';

export default function TermsOfUse() {
  return (
    <div style={{
      background: 'linear-gradient(to bottom, #0a0a0a 0%, #1a1a2e 50%, #0a0a0a 100%)',
      minHeight: '100vh',
      color: '#fff',
      fontFamily: "'Work Sans', sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;900&family=Work+Sans:wght@300;400;500;600&display=swap');
      `}</style>

      {/* Nav */}
      <nav style={{
        padding: '16px 24px',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        background: 'rgba(10,10,10,0.9)',
        backdropFilter: 'blur(10px)',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}>
        <div style={{ maxWidth: 800, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'linear-gradient(135deg, #8b5cf6, #4f46e5)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Camera size={18} color="white" />
            </div>
            <span style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, fontWeight: 700, color: '#fff' }}>PhotoVoice</span>
          </a>
          <a href="/" style={{
            fontSize: 14, color: '#9ca3af', textDecoration: 'none',
            padding: '8px 16px', border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: 50, transition: 'all 0.2s',
          }}
            onMouseOver={e => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'; }}
            onMouseOut={e => { e.currentTarget.style.color = '#9ca3af'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'; }}
          >
            ← Back to home
          </a>
        </div>
      </nav>

      {/* Content */}
      <main style={{ maxWidth: 800, margin: '0 auto', padding: '64px 24px' }}>
        <h1 style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: 'clamp(36px, 5vw, 52px)',
          fontWeight: 700,
          marginBottom: 8,
        }}>Terms of Use</h1>
        <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 48 }}>Last Updated: 19 Mar 2026</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>

          <Section title="1. Acceptance of Terms">
            Welcome to the website for the PhotoVoice beta program. These Terms of Use ("Terms") govern your use of our website and your participation in expressing interest in the beta test of our mobile application (the "App"). The website is operated by PhotoVoice ("Company," "we," "us," or "our"). By accessing or using our website, you agree to be bound by these Terms. If you do not agree to these Terms, you are not authorized to use this website.
          </Section>

          <Section title="2. Description of Service">
            The website provides information about our upcoming App and allows interested individuals to register their interest by submitting their email address. Submission of your email address indicates your interest in the beta program but does not guarantee you a spot in the beta test.
          </Section>

          <Section title="3. Eligibility">
            <p style={{ marginBottom: 16 }}>By using this website, you represent and warrant that:</p>
            <ul style={{ paddingLeft: 20, lineHeight: 2, color: '#9ca3af' }}>
              <li>You are at least 16 years of age.</li>
              <li>You are capable of forming a binding legal contract with the Company.</li>
              <li>You are not located in a country that is subject to a U.S. government embargo, or that has been designated by the U.S. government as a "terrorist supporting" country, and you are not listed on any U.S. government list of prohibited or restricted parties.</li>
            </ul>
          </Section>

          <Section title="4. User Conduct">
            <p style={{ marginBottom: 16 }}>You agree to use the website only for lawful purposes. You agree not to:</p>
            <ul style={{ paddingLeft: 20, lineHeight: 2, color: '#9ca3af' }}>
              <li>Provide false or misleading information, including a false email address.</li>
              <li>Use the website in any way that violates any applicable federal, state, local, or international law or regulation.</li>
              <li>Attempt to interfere with the proper working of the website.</li>
            </ul>
          </Section>

          <Section title="5. Intellectual Property Rights">
            The website and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by the Company, its licensors, or other providers of such material and are protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, create derivative works of, publicly display, or otherwise use any material on the website without our prior written consent.
          </Section>

          <Section title="6. Feedback">
            If you provide us with any feedback, suggestions, or ideas regarding the App or the beta program ("Feedback"), you hereby assign to us all rights in the Feedback and agree that we have the right to use it without any restriction or compensation to you.
          </Section>

          <Section title="7. Disclaimer of Warranties">
            <p style={{ textTransform: 'uppercase', letterSpacing: '0.02em' }}>
              Your use of the website is at your sole risk. The website is provided on an "as is" and "as available" basis. The Company expressly disclaims all warranties of any kind, whether express or implied, including the implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </p>
          </Section>

          <Section title="8. Limitation of Liability">
            <p style={{ textTransform: 'uppercase', letterSpacing: '0.02em' }}>
              To the fullest extent permitted by law, in no event will the Company, its affiliates, or their licensors, service providers, employees, agents, or officers be liable for damages of any kind arising out of or in connection with your use, or inability to use, the website.
            </p>
          </Section>

          <Section title="9. Indemnification">
            You agree to defend, indemnify, and hold harmless the Company and its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, and agents from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms or your use of the website.
          </Section>

          <Section title="10. Governing Law and Dispute Resolution">
            These Terms shall be governed by the laws of the Republic of Singapore, without regard to its conflict of law provisions. Any legal suit, action, or proceeding arising out of, or related to, these Terms or the website shall be instituted exclusively in the courts located in the Republic of Singapore, although we retain the right to bring any suit, action, or proceeding against you for breach of these Terms in your country of residence or any other relevant country. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.
          </Section>

          <Section title="11. Changes to Terms">
            We reserve the right to modify or revise these Terms at any time. If we make material changes, we will notify you by revising the "Last Updated" date at the top of these Terms. Your continued use of the website following the posting of changes constitutes your acceptance of such changes.
          </Section>

          <Section title="12. Termination">
            We may terminate or suspend your access to the website immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
          </Section>

          <Section title="13. Contact Us">
            If you have any questions about these Terms, please contact us at:{' '}
            <a href="mailto:support@photovoice.app" style={{ color: '#a78bfa' }}>support@photovoice.app</a>.
          </Section>

        </div>
      </main>

      <footer style={{ padding: '32px 24px', borderTop: '1px solid rgba(255,255,255,0.08)', textAlign: 'center' }}>
        <p style={{ color: '#374151', fontSize: 13 }}>© 2026 PhotoVoice. All rights reserved.</p>
      </footer>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 style={{
        fontFamily: 'Playfair Display, serif',
        fontSize: 22,
        fontWeight: 700,
        marginBottom: 16,
        color: '#fff',
      }}>{title}</h2>
      <div style={{ color: '#9ca3af', lineHeight: 1.8, fontSize: 15 }}>
        {children}
      </div>
    </div>
  );
}
